<template>
    <div class="source-form">
        <el-form
            ref="form"
            :model="formModel"
            :rules="formRules"
            label-width="110px"
            size="small"
            autocomplete="off"
        >
            <!-- 隐藏的伪输入框，拦截 Chrome / Edge 等浏览器密码管理器的暴力自动填充 -->
            <input
                type="text"
                name="prevent_autofill_username"
                tabindex="-1"
                autocomplete="off"
                style="position: absolute; top: -9999px; left: -9999px; opacity: 0; width: 0; height: 0; pointer-events: none;"
            >
            <input
                type="password"
                name="prevent_autofill_password"
                tabindex="-1"
                autocomplete="fetch-password"
                style="position: absolute; top: -9999px; left: -9999px; opacity: 0; width: 0; height: 0; pointer-events: none;"
            >

            <!-- 第一行：平台选择 + 代理源名称 -->
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item label="代理平台" prop="provider">
                        <el-radio-group v-model="formModel.provider" :disabled="isEdit" @change="handleProviderChange">
                            <el-radio-button label="juliang">巨量 IP</el-radio-button>
                            <el-radio-button label="ipzan">品赞 IP</el-radio-button>
                            <el-radio-button label="duomi">多米代理</el-radio-button>
                        </el-radio-group>
                        <span v-if="isEdit" class="tip-text" style="margin-left: 8px;">(已保存不可修改)</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="代理源名称" prop="name">
                        <el-input
                            v-model="formModel.name"
                            :placeholder="formModel.provider === 'juliang' ? '例如：巨量提取-1号' : (formModel.provider === 'duomi' ? '例如：多米全国-1号' : '例如：品赞按量-1号')"
                            clearable
                            autocomplete="off"
                        />
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- 巨量 IP 专属配置（直接使用官方接口，无版本区分） -->
            <template v-if="formModel.provider === 'juliang'">
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="业务编号" prop="credentials.tradeNo">
                            <el-input
                                v-model="formModel.credentials.tradeNo"
                                placeholder="巨量后台生成的 trade_no"
                                clearable
                                autocomplete="off"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="API Key" prop="credentials.apiKey">
                            <el-input
                                v-model="formModel.credentials.apiKey"
                                show-password
                                placeholder="巨量 API 签名密钥 key"
                                clearable
                                autocomplete="fetch-password"
                            />
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="自动加白">
                            <div class="switch-tip-row">
                                <el-switch
                                    v-model="formModel.providerConfig.autoWhite"
                                    :active-value="1"
                                    :inactive-value="0"
                                />
                                <span class="tip-text">提取时自动将出口 IP 加入白名单</span>
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="账号标识">
                            <el-input
                                v-model="formModel.credentials.account"
                                placeholder="选填，便于区分账号"
                                clearable
                                autocomplete="off"
                            />
                        </el-form-item>
                    </el-col>
                </el-row>
            </template>

            <!-- 品赞 IP 专属配置 -->
            <template v-if="formModel.provider === 'ipzan'">
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="套餐类型">
                            <el-select v-model="formModel.providerConfig.packageType" style="width: 100%">
                                <el-option label="包量 / 包时套餐" value="package" />
                                <el-option label="按量提取套餐" value="quantity" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="套餐编号" prop="credentials.tradeNo">
                            <el-input
                                v-model="formModel.credentials.tradeNo"
                                placeholder="品赞控制台购买编号 no"
                                clearable
                                autocomplete="off"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="套餐密钥" prop="credentials.apiKey">
                            <el-input
                                v-model="formModel.credentials.apiKey"
                                show-password
                                placeholder="品赞提取套餐密匙 secret"
                                clearable
                                autocomplete="new-password"
                            />
                        </el-form-item>
                    </el-col>
                </el-row>

                <!-- 按量提取专用选项 -->
                <el-row v-if="formModel.providerConfig.packageType === 'quantity'" :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="占用时长">
                            <el-select v-model="formModel.providerConfig.minute" style="width: 100%">
                                <el-option :value="1" label="1 分钟" />
                                <el-option :value="3" label="3 分钟" />
                                <el-option :value="5" label="5 分钟" />
                                <el-option :value="10" label="10 分钟" />
                                <el-option :value="15" label="15 分钟" />
                                <el-option :value="30" label="30 分钟" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="IP 池类型">
                            <el-select v-model="formModel.providerConfig.pool" style="width: 100%">
                                <el-option label="优质 IP 池 (quality)" value="quality" />
                                <el-option label="普通 IP 池 (ordinary)" value="ordinary" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="用户 ID">
                            <el-input
                                v-model="formModel.credentials.userId"
                                placeholder="品赞控制台用户ID (用于查余量)"
                                clearable
                                autocomplete="off"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="账号标识">
                            <el-input
                                v-model="formModel.credentials.account"
                                placeholder="选填，便于区分账号"
                                clearable
                                autocomplete="off"
                            />
                        </el-form-item>
                    </el-col>
                </el-row>
            </template>

            <!-- 多米代理专属配置 -->
            <template v-if="formModel.provider === 'duomi'">
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="API Key" prop="credentials.apiKey">
                            <el-input
                                v-model="formModel.credentials.apiKey"
                                placeholder="多米后台生成的 API Key (apikey)"
                                clearable
                                autocomplete="off"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="提取密码" prop="credentials.pwd">
                            <el-input
                                v-model="formModel.credentials.pwd"
                                placeholder="多米 API 提取密码 (pwd)"
                                clearable
                                autocomplete="fetch-password"
                            />
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="运营商">
                            <el-select v-model="formModel.providerConfig.operate" placeholder="全部运营商" style="width: 100%">
                                <el-option label="全部 (默认)" value="all" />
                                <el-option label="联通" value="1" />
                                <el-option label="电信" value="2" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="账号标识">
                            <el-input
                                v-model="formModel.credentials.account"
                                placeholder="选填，便于区分账号"
                                clearable
                                autocomplete="off"
                            />
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20">
                    <el-col :span="24">
                        <el-form-item label="地区说明">
                            <span class="tip-text" style="line-height: 36px; color: #909399;">多米代理当前仅支持全国范围提取</span>
                        </el-form-item>
                    </el-col>
                </el-row>
            </template>

            <!-- 排序与状态 -->
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item label="排序" prop="sortOrder">
                        <el-input-number
                            v-model="formModel.sortOrder"
                            :step="10"
                            controls-position="right"
                            style="width: 100%"
                            placeholder="越小越靠前"
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="启用状态">
                        <el-switch v-model="formModel.enabled" active-text="启用" inactive-text="停用" />
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- 备注说明 -->
            <el-row :gutter="20">
                <el-col :span="24">
                    <el-form-item label="备注说明">
                        <el-input
                            v-model="formModel.remark"
                            type="textarea"
                            :rows="2"
                            placeholder="选填备注"
                            clearable
                            autocomplete="off"
                        />
                    </el-form-item>
                </el-col>
            </el-row>

            <div class="form-footer">
                <el-button @click="$emit('close')">取消</el-button>
                <el-button type="primary" :loading="saving" @click="handleSave">保存</el-button>
            </div>
        </el-form>
    </div>
</template>

<script>
import proxySourceService from '@/api/order/ProxySourceService'

function clone(value) {
    return JSON.parse(JSON.stringify(value || {}))
}

function createDefaultModel() {
    return {
        name: '',
        provider: 'juliang',
        enabled: true,
        sortOrder: 0,
        credentials: {
            account: '',
            userId: '',
            tradeNo: '',
            apiKey: '',
            pwd: ''
        },
        providerConfig: {
            autoWhite: 1,
            packageType: 'package',
            minute: 1,
            pool: 'quality',
            mode: 'whitelist',
            operate: 'all'
        },
        defaultParams: {
            area: ['all'],
            num: 1,
            protocol: 'http',
            resultType: 'text'
        },
        remark: ''
    }
}

export default {
    name: 'ProxySourceForm',
    props: {
        propFormModel: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            formModel: createDefaultModel(),
            saving: false
        }
    },
    computed: {
        isEdit() {
            return Boolean(this.formModel && this.formModel._id)
        },
        formRules() {
            const rules = {
                name: [{ required: true, message: '请输入代理源名称', trigger: 'blur' }],
                provider: [{ required: true, message: '请选择平台', trigger: 'change' }]
            }
            if (this.formModel.provider === 'juliang') {
                rules['credentials.tradeNo'] = [{ required: true, message: '请输入业务编号 (trade_no)', trigger: 'blur' }]
                rules['credentials.apiKey'] = [{ required: true, message: '请输入 API Key', trigger: 'blur' }]
            } else if (this.formModel.provider === 'ipzan') {
                rules['credentials.tradeNo'] = [{ required: true, message: '请输入品赞套餐购买编号 (no)', trigger: 'blur' }]
                rules['credentials.apiKey'] = [{ required: true, message: '请输入提取套餐密匙 (secret)', trigger: 'blur' }]
            } else if (this.formModel.provider === 'duomi') {
                rules['credentials.apiKey'] = [{ required: true, message: '请输入多米 API Key (apikey)', trigger: 'blur' }]
                rules['credentials.pwd'] = [{ required: true, message: '请输入多米提取密码 (pwd)', trigger: 'blur' }]
            }
            return rules
        }
    },
    watch: {
        propFormModel: {
            immediate: true,
            handler(value) {
                const source = value ? clone(value) : createDefaultModel()
                source.sortOrder = source.sortOrder !== undefined && source.sortOrder !== null ? Number(source.sortOrder) : 0
                source.credentials = source.credentials || {}
                source.providerConfig = {
                    ...createDefaultModel().providerConfig,
                    ...(source.providerConfig || {})
                }
                source.defaultParams = {
                    ...createDefaultModel().defaultParams,
                    ...(source.defaultParams || {})
                }
                this.formModel = source
            }
        }
    },
    methods: {
        handleProviderChange() {
            this.formModel.credentials = this.formModel.credentials || {}
            this.formModel.providerConfig = {
                ...createDefaultModel().providerConfig,
                ...(this.formModel.providerConfig || {})
            }
        },
        handleSave() {
            this.$refs.form.validate(valid => {
                if (!valid) return
                this.saving = true
                const payload = clone(this.formModel)
                const request = payload._id
                    ? proxySourceService.updateById(payload._id, payload)
                    : proxySourceService.insert(payload)
                request.then(res => {
                    this.$message.success(res.message || '保存成功')
                    this.$emit('refresh')
                    this.$emit('close')
                }).finally(() => {
                    this.saving = false
                })
            })
        }
    }
}
</script>

<style scoped>
.source-form {
    padding: 0 10px;
}

.switch-tip-row {
    display: flex;
    align-items: center;
    gap: 8px;
    height: 32px;
}

.tip-text {
    font-size: 12px;
    color: #909399;
    line-height: 1.2;
}

.form-footer {
    display: flex;
    justify-content: flex-end;
    margin-top: 14px;
    padding-top: 16px;
    border-top: 1px solid #ebeef5;
}
</style>
